module.exports = __webpack_public_path__ + "static/media/forgot-password.9faba3c1.svg";